import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import { servicoApi } from 'app/services/api/servicoApi';
import React from 'react';

const SelectServico = ({
  id,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  required,
  autoFocus,
  disabled,
  disableClearable,
}) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      autoFocus={autoFocus}
      required={required}
      disableClearable={disableClearable}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        if (option?.codigo) {
          return `${option?.codigo} - ${option?.descricao}`;
        } else {
          return option?.descricao;
        }
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await servicoApi.pesquisar({
          size: 100,
          sort: 'descricao',
          page: next,
          q: query,
        });

        const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, nextPage: links.next, totalItems };
      }}
      fetchOnFocus
      disabled={disabled}
    />
  );
};

export default SelectServico;
